(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-image-text-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function(){
  document.querySelectorAll('.custom-image-text-section img').forEach(img => {
    const fit = img.dataset.fit;
    const border = img.dataset.border;
    if(fit) img.style.objectFit = fit;
    if(border) img.style.border = border;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-new"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const faqButtons = document.querySelectorAll('.faq-accordion .faq-question');
  faqButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      faqButtons.forEach(b => b.setAttribute('aria-expanded', 'false'));
      document.querySelectorAll('.faq-accordion .faq-answer').forEach(a => a.hidden = true);

      if (!expanded) {
        btn.setAttribute('aria-expanded', 'true');
        const answer = document.getElementById(btn.getAttribute('aria-controls'));
        if(answer) answer.hidden = false;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1280px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  const initialize = (owner) => {
    const slot = owner.querySelector('[data-tbw-preview-slot="desktop"]');
    const preview = owner.querySelector('[data-tbw-preview]');
    if (!slot || !preview || slot.dataset.tbwBalanced === 'true') return;
    slot.dataset.tbwBalanced = 'true';
    let frame = 0;
    let lastSpace = -1;
    const update = () => {
      frame = 0;
      const mobileSlot = owner.querySelector('[data-tbw-preview-slot="mobile"]');
      const pairedSlot = owner.querySelector('[data-tbw-preview-slot="paired"]');
      const technicalSlot = owner.querySelector('[data-tbw-preview-slot="technical"]');
      const destination = window.matchMedia('(min-width: 990px)').matches && pairedSlot
        ? pairedSlot
        : technicalSlot || (window.matchMedia('(max-width: 749px)').matches && mobileSlot ? mobileSlot : slot);
      if (!destination.contains(preview)) destination.appendChild(preview);
      const downloads = owner.querySelector('.tbw-product-downloads');
      let space = 0;
      if (window.matchMedia('(min-width: 990px)').matches && downloads && slot.contains(preview) && !owner.querySelector('[data-tbw-support-panel]')) {
        const guideSlot = owner.querySelector('.tbw-feed-guide-slot');
        const guide = guideSlot?.querySelector('.tbw-feed-guide');
        const contentBottom = guide
          ? guideSlot.getBoundingClientRect().top + parseFloat(getComputedStyle(guideSlot).paddingTop) + guide.getBoundingClientRect().height
          : downloads.getBoundingClientRect().bottom;
        const available = contentBottom - slot.getBoundingClientRect().top;
        space = Math.max(0, Math.floor((available - preview.getBoundingClientRect().height) / 2));
      }
      if (space !== lastSpace) {
        slot.style.setProperty('--tbw-preview-space', space + 'px');
        lastSpace = space;
      }
    };
    const queue = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    const observer = new ResizeObserver(queue);
    const observe = [owner.querySelector('product-info'), preview, ...slot.parentElement.children];
    observe.filter(node => node && node !== slot).forEach(node => observer.observe(node));
    window.addEventListener('resize', queue);
    owner.addEventListener('load', queue, true);
    document.fonts?.ready.then(queue);
    queue();
  };
  document.querySelectorAll('.tbw-40a-tap').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    const owner = event.target.matches('.tbw-40a-tap') ? event.target : event.target.querySelector('.tbw-40a-tap');
    if (owner) initialize(owner);
  });
})();

(() => {
  const initializeSelection = (owner) => {
    const dataNode = owner.querySelector('[data-tbw-40a-spec-data]');
    const picker = owner.querySelector('variant-selects');
    const familyTable = owner.querySelector('.product__media-wrapper .specs-table');
    if (!dataNode || !picker || !familyTable || owner.querySelector('.tbw-40a-selection')) return;
    let data, variants;
    try { data = JSON.parse(dataNode.textContent); variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent); } catch { return; }
    const familyRows = Array.from(familyTable.rows, row => Array.from(row.cells, cell => cell.textContent.trim()));
    const familyValue = name => familyRows.find(row => row[0] === name)?.[1] || '';
    const wrapper = document.createElement('section');
    wrapper.className = 'tbw-40a-selection';
    const heading = document.createElement('h2');
    heading.id = owner.id + '-specifications';
    heading.textContent = data.specifications;
    wrapper.setAttribute('aria-labelledby', heading.id);
    const caption = document.createElement('p');
    caption.textContent = data.caption;
    const table = document.createElement('table');
    if (data.handle === '3-phase-drop-cord') table.dataset.connectorVoltages = 'true';
    const head = table.createTHead().insertRow();
    [data.specification, data.selection].forEach(text => { const th = document.createElement('th'); th.scope = 'col'; th.textContent = text; head.append(th); });
    const body = table.createTBody();
    const family = document.createElement('details');
    const summary = document.createElement('summary'); summary.textContent = data.family; family.append(summary);
    if (familyTable.previousElementSibling?.tagName === 'H2') familyTable.previousElementSibling.remove();
    const desktopSlot = document.createElement('div');
    familyTable.before(desktopSlot); desktopSlot.append(wrapper); family.append(familyTable); wrapper.append(heading, caption, table, family);
    const mobile = window.matchMedia('(max-width: 749px)');
    const position = () => {
      const selectionSlot = owner.querySelector('[data-tbw-tap-specs-slot]');
      if (selectionSlot) selectionSlot.append(wrapper);
      else if (mobile.matches) picker.after(wrapper); else desktopSlot.append(wrapper);
    };
    mobile.addEventListener('change', position);
    position();
    const render = () => {
      const choices = Array.from(picker.querySelectorAll('select, fieldset'), node => node.tagName === 'SELECT' ? node.value : node.querySelector('input:checked')?.value);
      const variant = variants.find(item => item.options.every((value, index) => choices[index] === value));
      body.replaceChildren();
      const row = (label, value) => { if (!value) return; const tr = body.insertRow(); const th = document.createElement('th'); th.scope = 'row'; th.textContent = label; tr.append(th); tr.insertCell().textContent = value; };
      if (owner.hasAttribute('data-tbw-simple-tap')) {
        const selectedReceptacle = choices.join(' ').match(/(L?\d+-(15|20|30|50|60)R?)(?=\s|$)/i);
        familyRows.forEach(([label, value]) => {
          if (!label || !value) return;
          const index = data.options.findIndex(name => name.toLowerCase() === label.toLowerCase());
          if (selectedReceptacle && label === 'NEMA') row(label, selectedReceptacle[1].toUpperCase().replace(/R?$/, 'R'));
          else if (selectedReceptacle && label === 'Amperage') row(label, selectedReceptacle[2] + 'A');
          else row(label, index >= 0 ? choices[index] : value);
        });
        data.options.forEach((name, index) => {
          if (!familyRows.some(([label]) => label.toLowerCase() === name.toLowerCase())) row(name, choices[index]);
        });
        if (variant?.sku) row(data.sku, variant.sku);
        caption.textContent = variant ? data.caption : data.invalid;
        return;
      }
      row(data.system, data.system_value);
      row(data.grounding, data.grounding_value);
      if (familyValue('Phase')) row('Phase', familyValue('Phase'));
      const supplyByProduct = {'breakered-outlet-box':'120V', 'power-drop-cord':'120V', '240v-power-drop-cord':'240V', '240v-breakered-outlet-box':'240V', '208v-breakered-outlet-box':'208V', '208v-powerdrop-cord':'208V', '3-phase-drop-cord':(choices[0] || '').split(' | ')[1]};
      const voltage = data.handle === '40a-3-phase-outlet-box' ? ({'L15-20 Single Twist Lock':'208V', 'L16-20 Single Twist Lock':'480V'}[choices[0]] || '') : supplyByProduct[data.handle];
      if (voltage) row('Voltage', /^\d+$/.test(voltage) ? voltage + 'V' : voltage);
      data.options.forEach((name, index) => row(name, choices[index]));
      row(data.sku, variant?.sku || data.invalid);
      caption.textContent = variant ? data.caption : data.invalid;
    };
    picker.addEventListener('change', render);
    render();
  };
  document.querySelectorAll('[data-tbw-tap-layout]').forEach(initializeSelection);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-tbw-tap-layout]').forEach(initializeSelection);
  });
})();
(() => {
  const initialize = owner => {
    const panel = owner.querySelector('[data-tbw-support-panel]');
    const home = owner.querySelector('[data-tbw-support-home]');
    const media = owner.querySelector('.product-media-block.desktop-gallery');
    const guides = owner.querySelector('.tbw-tap-guides');
    const guidesHome = owner.querySelector('[data-tbw-guides-home]');
    const guidesDesktop = owner.querySelector('[data-tbw-guides-desktop]');
    if (!panel || !home || !media || panel.dataset.positioned) return;
    panel.dataset.positioned = 'true';
    const standard40a = owner.classList.contains('tbw-40a-tap');
    const video = standard40a ? owner.querySelector('.tbw-tap-video') : null;
    const videoHome = video ? document.createElement('span') : null;
    if (videoHome) { videoHome.hidden = true; video.before(videoHome); }
    const phaseGuide = standard40a ? null : owner.querySelector('.tbw-feed-guide-slot');
    const phaseGuideHome = phaseGuide ? document.createElement('span') : null;
    if (phaseGuideHome) { phaseGuideHome.hidden = true; phaseGuide.before(phaseGuideHome); }
    const downloads = panel.querySelector('.tbw-product-downloads');
    if (downloads) {
      const more = document.createElement('details'); more.className = 'tbw-download-more';
      const summary = document.createElement('summary'); summary.textContent = panel.dataset.moreLabel; more.append(summary);
      const family = downloads.querySelector('[data-family-secondary]'); if (family) more.append(family);
      const list = document.createElement('ul'); list.className = 'product-btns-block';
      downloads.querySelectorAll('.product-btns-block > li').forEach(item => {
        if (item.matches('.tbw-step-request,.zip-all,.tbw-resource-manual')) list.append(item);
        else if (item.matches('.rvt')) {
          const link = item.querySelector('a');
          if (link) link.textContent = panel.dataset.revitLabel + (/\.rfa(?:[?#]|$)/i.test(link.href)?' (.RFA)':/\.rvt(?:[?#]|$)/i.test(link.href)?' (.RVT)':' (.ZIP)');
          item.querySelectorAll('p').forEach(note => { note.textContent = panel.dataset.revitNote; });
        }
      });
      more.append(list); downloads.append(more);
      downloads.querySelectorAll('.tbw-product-downloads__more').forEach(node => node.remove());
      const library = document.createElement('p'); library.className = 'tbw-product-downloads__more';
      const link = document.createElement('a'); link.href = '/pages/bim-design-tools'; link.textContent = panel.dataset.libraryLabel + ' →'; library.append(link); downloads.append(library);
    }
    const desktop = window.matchMedia('(min-width: 990px)');
    const place = () => {
      if (desktop.matches) {
        const gallery = media.querySelector(':scope > .desktop_only');
        if (gallery) gallery.after(panel); else media.append(panel);
        if (video) panel.after(video);
        if (phaseGuide) media.append(phaseGuide);
        if (guides) {
          if (standard40a && guidesHome) guidesHome.after(guides);
          else if (guidesDesktop) guidesDesktop.append(guides);
        }
      } else {
        home.after(panel);
        if (videoHome) videoHome.after(video);
        if (standard40a && guides && guidesHome) guidesHome.after(guides);
        if (phaseGuideHome) phaseGuideHome.after(phaseGuide);
        if (!standard40a && guides && guidesHome) guidesHome.after(guides);
      }
    };
    place(); desktop.addEventListener('change', place);
  };
  document.querySelectorAll('[data-tbw-tap-layout]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-tbw-tap-layout]').forEach(initialize);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
